<template>
  <ul class="bucket_folder_list">
    <li v-for="parent in node" :key="parent.id" class="bucket_folder_list_item"
      :class="parent.sub_folders.length > 0 ? 'sub_folder_dd' : ''">
      <label class="bucket_folder_name_wrp option_custom_radio" v-on:click="folderIdForMoveFun(parent.id)"
        v-if="(parentId && parentId.split('/')[0]) != parent.name">
        <input type="radio" :value="parent.id" name="radioOp">
        <span class="radio"></span>
        <i class="fa fa-folder mr-2" aria-hidden="true"></i>
        <span class="bucket_folder_list_name">{{ parent.name }}</span>
      </label>
      <template v-if="parent.sub_folders && parent.sub_folders.length > 0">
        <ul class="bucket_folder_list">
          <li class="bucket_folder_list_item" v-for="child in parent.sub_folders" :key="child.id"
            :class="child.sub_folders.length > 0 ? 'sub_folder_dd' : ''">
            <template v-if="child.is_folder">
              <label class="bucket_folder_name_wrp option_custom_radio" v-on:click="folderIdForMoveFun(child.id)"
                v-if="(parentId && parentId.split('/')[1]) != child.name">
                <input type="radio" :value="child.id" name="radioOp">
               <span class="radio"></span>
                <i class="fa fa-folder mr-2" aria-hidden="true"></i>
                <span class="bucket_folder_list_name">{{ child.name }}</span>
              </label>
            </template>
            <node v-if="child.sub_folders" :node="child.sub_folders"></node>
          </li>
        </ul>
      </template>
    </li>
  </ul>
</template>
<script>
/*eslint-disable */
import {
  bus
} from '@/main';
export default {
  name: "node",
  props: {
    node: Array,
    parentId: String
  },
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    folderIdForMoveFun(FolderId) {
      bus.$emit('getSelectFolderID', FolderId);
    }
  },
};
</script>
<style lang="scss" scoped>
.bucket_folder_list {
  margin: 0;
  padding-left: 0px;

  & .bucket_folder_list {
    padding-left: 15px;
  }

  input[type="checkbox"] {
    margin-right: 8px;
  }

  input[type="radio"] {
    margin-right: 8px;
  }

  .fa.fa-folder {
    color: #ffe9e9;
  }



  $border-color_1:#ffd400;

  .option_custom_radio {
    margin: 0;
    line-height: 1;
    position: relative;

    >input[type="radio"] {
      opacity: 0;
      position: absolute;

      + {
        .radio {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          background: rgba(201, 219, 220, 0.1);
          border: 2px solid #ffe9e9;
          border-radius: 50%;
          position: relative;
          cursor: pointer;
          margin-right: 15px;

          &:after {
            position: absolute;
            content: "";
            width: 12px;
            height: 12px;
            background: #ffe9e9;
            border-radius: 50%;
            margin: 0 auto;
            left: 0;
            right: 0;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
            line-height: 1;
          }
        }
      }

      &:checked {
        + {
          .radio {
            border-color: $border-color_1;

            &:after {
              background: $border-color_1;
            }
          }
        }
      }
    }
  }

  .bucket_folder_list_item {
    color: #d6d6d6;
    font-size: 16px;
    position: relative;
    cursor: pointer;
    margin-top: 10px;

    // &:first-child {
    //   margin-top: 0px;
    // }

    .bucket_folder_name_wrp {
      position: relative;
      margin: 0;
      line-height: 1;
      cursor: pointer;
      display: flex;
      align-items: center;
      color: #ffe9e9;
      font-size: 18px;

      a {
        display: flex;
        line-height: 1;
        align-items: baseline;
        color: #d6d6d6;
        text-decoration: none;

        &:hover,
        &.router-link-exact-active {
          color: #ffd700;
        }
      }
    }

    .bucket_folder_list_name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      vertical-align: middle;
    }

    .bucket_folder_name_wrp:hover>.bucket_option_dd {
      display: block;
    }

    .bucket_option_dd {
      position: absolute;
      top: 0;
      right: 0;
      display: none;

      .fa-chevron-down {
        font-size: 14px;

        &:hover {
          color: #ffd700;
        }
      }

      &.show .fa-chevron-down {
        color: #ffd700;
      }

      &.show {
        display: block;
      }

      .bucket_option_list {
        padding: 5px 10px;
        background: rgba(0, 0, 0, 0.92);
        box-shadow: 0px 0px 3px rgba(255, 255, 255, 0.1);

        .bucket_option_item {
          color: #d6d6d6;
          font-size: 16px;
          margin-top: 10px;

          &:hover {
            color: #ffd700;
          }

          &:first-child {
            margin-top: 0px;
          }
        }
      }
    }

    .show_sub_bucket_list_icon {
      position: absolute;
      top: -2px;
      left: -15px;

      & .fa {
        font-size: 13px;
        transform: rotate(0);
        -webkit-transform: rotate(0);
        -moz-transform: rotate(0);
        transition: all ease 0.5s;
        -webkit-transition: all ease 0.5s;
        -moz-transition: all ease 0.5s;
      }
    }

    &.show_sub_bucket>.bucket_folder_name_wrp>.show_sub_bucket_list_icon>.fa {
      color: #ffd700;
      transform: rotate(90deg);
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
    }
  }
}
</style>